export default __webpack_public_path__ + "static/media/DreamJobs1_02.5f71eb84.png";